import { render, staticRenderFns } from "./SeriesListTable.vue?vue&type=template&id=622eee9d&"
import script from "./SeriesListTable.vue?vue&type=script&lang=js&"
export * from "./SeriesListTable.vue?vue&type=script&lang=js&"
import style0 from "./SeriesListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports